import { render, staticRenderFns } from "./VippsCheckoutForm.vue?vue&type=template&id=8860f20a&scoped=true"
import script from "./VippsCheckoutForm.vue?vue&type=script&lang=ts"
export * from "./VippsCheckoutForm.vue?vue&type=script&lang=ts"
import style0 from "./VippsCheckoutForm.vue?vue&type=style&index=0&id=8860f20a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8860f20a",
  null
  
)

export default component.exports